module.exports = "#u-menu{\r\n    list-style: none;\r\n    padding-left:0px;\r\n    margin:0px;\r\n    width:100%;\r\n    display: block;\r\n}\r\n\r\n#u-menu li{\r\n    float:left;\r\n}\r\n\r\n#u-menu li a{\r\n    display:inline-block;\r\n    padding:5px 10px;\r\n    width:100px;\r\n    text-align: center;\r\n    text-decoration: none;\r\n    color:#212121;\r\n    -webkit-transition: .5s;\r\n    transition: .5s;\r\n}\r\n\r\n#u-menu li a:hover{\r\n    background:#3aceff;\r\n}\r\n\r\n#u-menu img{\r\n    display: inline-block;\r\n    width:50px;\r\n\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/hrms.component.css
// module id = ./src/app/hrms/hrms.component.css
// module chunks = main